import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useUpdateWorkpapers } from '../../queries/use-update-workpapers';
import { WorkpaperStatusEnum } from '../../types/workpaper';
import plural from '../../utilities/plural';

type UnarchiveWorkpapersConfirmProps = {
    workpaperIds: string[];
    onClose: () => void;
};

function UnarchiveWorkpapersConfirm({ workpaperIds, onClose }: UnarchiveWorkpapersConfirmProps): JSX.Element {
    const updateWorkpapersQuery = useUpdateWorkpapers();

    function update(): void {
        updateWorkpapersQuery.mutate(
            workpaperIds.map((id) => ({ id, fields: { status: WorkpaperStatusEnum.ACTIVE } })),
            {
                onSuccess: () => {
                    toastNotification('success', `Unarchived ${workpaperIds.length} workpapers!`);
                },
                onError: (err) => {
                    const results = err.response?.data?.results ?? [];
                    const errors = results.filter((r: { statusCode: number }) => r.statusCode >= 400);
                    const success = results.filter((r: { statusCode: number }) => r.statusCode < 400);

                    if (success.length > 0) {
                        toastNotification('success', `Unarchived ${success.length} ${plural(success.length, 'workpaper', 'workpapers')}!`);
                    }
                    toastNotification(
                        'error',
                        `Unable to unarchive ${errors.length} ${plural(success.length, 'workpaper', 'workpapers')}!`
                    );
                },
                onSettled: () => onClose(),
            }
        );
    }

    return (
        <Dialog
            title={`Unarchive ${workpaperIds.length === 1 ? 'Workpaper' : 'Workpapers'}`}
            description={`Do you want to unarchive ${
                workpaperIds.length > 1 ? `${workpaperIds.length} workpapers` : 'this workpaper'
            }? This worksheet/s will become active.`}
            isOpen={true}
            primaryAction="Unarchive"
            secondaryAction="Cancel"
            type="info"
            onClose={onClose}
            onPrimaryActionClick={update}
            onSecondaryActionClick={onClose}
            isLoading={updateWorkpapersQuery.isLoading}
        />
    );
}
export default UnarchiveWorkpapersConfirm;
